import React, { createContext, memo, useContext } from 'react';

import PropTypes from 'prop-types';

export const ReturnIdContext = createContext(undefined);

export const useReturnIdContext = () => useContext(ReturnIdContext);

const ReturnIdContextProvider = ({ children, returnId }) => (
  <ReturnIdContext.Provider value={returnId}>{children}</ReturnIdContext.Provider>
);

export default memo(ReturnIdContextProvider);

ReturnIdContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
  returnId: PropTypes.string,
};
